export const getIsOldVersion = (state) => state.isOldVersion